import APIClient from '../../../lib/api';

function errorMessage(error, fallback) {
  const detail = error.response?.data?.detail;
  if (typeof detail === 'string') {
    return detail;
  }
  if (Array.isArray(detail)) {
    return detail.map((item) => item.msg || 'Μη έγκυρα δεδομένα').join(', ');
  }
  return error.message || fallback;
}

class LicenceService {
  async getAll(params = {}) {
    try {
      const response = await APIClient.licences.getAll(params);
      return {
        success: true,
        data: response.data.data || [],
        total: response.data.total || 0,
      };
    } catch (error) {
      return { success: false, error: errorMessage(error, 'Σφάλμα φόρτωσης αδειών') };
    }
  }

  async getById(id) {
    try {
      const response = await APIClient.licences.getById(id);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: errorMessage(error, 'Σφάλμα φόρτωσης κλειδιού') };
    }
  }

  async getProducts(params = {}) {
    try {
      const response = await APIClient.licences.getProducts(params);
      return { success: true, data: response.data || [] };
    } catch (error) {
      return { success: false, error: errorMessage(error, 'Σφάλμα φόρτωσης plugins') };
    }
  }

  async saveProduct(data, id = null) {
    try {
      const response = id
        ? await APIClient.licences.updateProduct(id, data)
        : await APIClient.licences.createProduct(data);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: errorMessage(error, 'Σφάλμα αποθήκευσης plugin') };
    }
  }

  async deleteProduct(id) {
    try {
      await APIClient.licences.deleteProduct(id);
      return { success: true };
    } catch (error) {
      return { success: false, error: errorMessage(error, 'Σφάλμα διαγραφής plugin') };
    }
  }

  async unblockDomain(id, domain) {
    try {
      const response = await APIClient.licences.unblockDomain(id, domain);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: errorMessage(error, 'Σφάλμα ξεμπλοκαρίσματος') };
    }
  }

  async getStatistics(params = {}) {
    try {
      const response = await APIClient.licences.getStatistics(params);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: errorMessage(error, 'Σφάλμα φόρτωσης στατιστικών') };
    }
  }

  async create(data) {
    try {
      const response = await APIClient.licences.create(data);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: errorMessage(error, 'Σφάλμα δημιουργίας κλειδιού') };
    }
  }

  async update(id, data) {
    try {
      const response = await APIClient.licences.update(id, data);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: errorMessage(error, 'Σφάλμα ενημέρωσης κλειδιού') };
    }
  }

  async updateStatus(id, status) {
    try {
      const response = await APIClient.licences.updateStatus(id, status);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: errorMessage(error, 'Σφάλμα αλλαγής κατάστασης') };
    }
  }
}

export default new LicenceService();
